module.exports = __webpack_public_path__ + "img/s3.543f2eb7.jpg";